import { render, staticRenderFns } from "./LeaderboardBanner.vue?vue&type=template&id=98ae5ed4&scoped=true"
import script from "./LeaderboardBanner.vue?vue&type=script&lang=js"
export * from "./LeaderboardBanner.vue?vue&type=script&lang=js"
import style0 from "./LeaderboardBanner.vue?vue&type=style&index=0&id=98ae5ed4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98ae5ed4",
  null
  
)

export default component.exports